import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './ContentWrapper.module.scss';

interface IContentWrapper {
  children: React.ReactNode;
  className?: string;
}

const ContentWrapper: React.FC<IContentWrapper> = ({ children, className }) => (
  <div className={cx(styles.contentWrapper, className)}>{children}</div>
);

ContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ContentWrapper.defaultProps = {
  className: undefined,
};

export default ContentWrapper;
